 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTDEDI from '@/components/Text/dedi'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTPRE from '@/components/Text/pre'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTPT1 from '@/components/Text/pt1'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTPT2 from '@/components/Text/pt2'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTNAMEINDEX from '@/components/Text/nameindex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/scriptureindex'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTATA from '@/components/Text/ata'
 import TEXTMOREIVP from '@/components/Text/moreivp'
 import TEXTRIGHTS from '@/components/Text/rights'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/pre",
 			"name" : "Text/pre",
 			"component" : TEXTPRE
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/pt1",
 			"name" : "Text/pt1",
 			"component" : TEXTPT1
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js